module.exports = __webpack_public_path__ + "static/media/10-points.f5836e25.png";